import api from '@/services/Api'
import { get } from 'lodash'

export default {
    GetDegrees () {
        return api().post('/user/degrees')
    },
    GetNationalities () {
        return api().post('/user/nationalities')
    },
    GetReligions () {
        return api().post('/user/religions')
    },
    CheckEmailExist (credentials) {
        return api().post('/user/email-exist', credentials)
    },
    RegisterNewStudents (credentials) {
        return api().post('/user/registerApplicant', credentials)
    },
    GetStudentNo (credentials) {
        return api().post('/user/checkStudentNo', credentials)
    },
    GetStudentDetails (credentials) {
        return api().post('/user/studentDetails', credentials)
    },
    RegisterContinuingStudent (credentials) {
        return api().post('/user/registerStudent', credentials)
    },
    Login (credential) {
        return api().post('/user/login', credential)
    },
    GetLoggedStudent (credential) {
        return api().get('/user/student')
    },
    LogoutStudent () {
        return api().post('/user/logout')
    },
    VerifyStudentEmail (credential) {
        return api().post('/user/verifyemail', credential)
    },
    VerifyNewStudentAccount (credential) {
        return api().post('/user/confirm/account', credential)
    },
    CreateNewStudentPassword (credential) {
        return api().put('/user/update/new-student-password', credential)
    },
    ReUploadNewRequirements (credential) {
        return api().post('/user/reupload/requirements' , credential)
    },
    ForgotStudentPassword (credentials) {
        return api().post('/user/forgot/password', credentials)
    },
    CheckPasswordResetToken (credentials) {
        return api().post('/user/check/password/reset/token', credentials)
    },
    ChangePassword (credentials) {
        return api().put('/user/update/student/password', credentials)
    },
    CheckDocReference (credentials) {
        return api().post('/user/check/college/code', credentials)
    },
    GetTermByCollegeID (credentials) { 
        return api().post('/user/set/term', credentials)
    },
    GetSubjectsByStudentNo (credentials) {
        return api().post('/user/student/subject', credentials)
    },
    SaveSubjectsEnrolled (credentials) {
        return api().post('/user/student/set/subject/enrolled' , credentials)
    },
    GetProgramEnrolled (credentials) {
        return api().post('/user/student/program/enrolled', credentials)
    },
    GetSubjectEnrolled (credentials) {
        return api().post('/user/student/subjects/enrolled', credentials)
    },
    RemoveSubjectEnrolled (credentials) {
        return api().post('/user/remove/subject/enrolled' , credentials)
    },
    GetOfferSchedule (credentials) {
        return api().post('/user/GetSelectedOfferSchedule', credentials)
    },
    GetBackAccount (credentials) {
        return api().get(`/user/student/${credentials.studentNo}/back/account/${credentials.term}`);
    },
    GetAllFees (credentials) {
        return api().post('/user/student/fees', credentials)
    },
    GetPrivacyPolicy () {
        return api().get('/user/privacy/policy');
    },
    GetDownPayment (credentials) {
        return api().get(`/user/student/${credentials.studentNo}/down-payment/${credentials.term}`)
    },
    GetCollegeID (credential) {
        return api().get(`/user/student/college/${credential.programID}`);
    },
    GetBlockCodes (credentials) {
        return api().get(`/user/student/subject/block-codes/${credentials.programID}/${credentials.term}`)
    },
    GetSubjectsOnBlockCode (credentials) {
        return api().post('/user/student/set/subject/block-codes', credentials)
    },
    GetDragonPayUrl (credentials) {
        return api().post('/user/GetDragonPayUrl' , credentials)
    },
    CheckDpayDigest (credentials) {
        return api().get('/user/CheckDpayDigest', credentials)
    },
    GetTotalCredits (credentials) {
        return api().get(`/user/student/total-unit?yearLevel=${credentials.yearLevel}&programID=${credentials.programID}&term=${credentials.term}`);
    },
    GetAccounts (credential) {
        return api().get(`/user/student/account/${credential}`);
    },
    GetStudentAccountsDetails (credentials) {
        return api().get(`/user/student/account-detail/${credentials.studentNo}/${credentials.term}`);
    },
    GetValidDays () {
        return api().get('/user/valid-days');
    },
    GetRegistrarName () {
        return api().get('/user/registrar/name');
    }


}